// 32 provincias oficiales de República Dominicana, cada una con un color fijo
// para identificar visualmente el destino de cada envío.
export const DR_PROVINCES = [
  { name: "Distrito Nacional", color: "#DC2626" },
  { name: "Azua", color: "#EA580C" },
  { name: "Bahoruco", color: "#D97706" },
  { name: "Barahona", color: "#CA8A04" },
  { name: "Dajabón", color: "#65A30D" },
  { name: "Duarte", color: "#16A34A" },
  { name: "Elías Piña", color: "#059669" },
  { name: "El Seibo", color: "#0D9488" },
  { name: "Espaillat", color: "#0891B2" },
  { name: "Hato Mayor", color: "#0284C7" },
  { name: "Hermanas Mirabal", color: "#2563EB" },
  { name: "Independencia", color: "#4F46E5" },
  { name: "La Altagracia", color: "#7C3AED" },
  { name: "La Romana", color: "#9333EA" },
  { name: "La Vega", color: "#C026D3" },
  { name: "María Trinidad Sánchez", color: "#DB2777" },
  { name: "Monseñor Nouel", color: "#E11D48" },
  { name: "Monte Cristi", color: "#B91C1C" },
  { name: "Monte Plata", color: "#9A3412" },
  { name: "Pedernales", color: "#92400E" },
  { name: "Peravia", color: "#3F6212" },
  { name: "Puerto Plata", color: "#166534" },
  { name: "Samaná", color: "#115E59" },
  { name: "San Cristóbal", color: "#155E75" },
  { name: "San José de Ocoa", color: "#075985" },
  { name: "San Juan", color: "#1E40AF" },
  { name: "San Pedro de Macorís", color: "#3730A3" },
  { name: "Sánchez Ramírez", color: "#5B21B6" },
  { name: "Santiago", color: "#6B21A8" },
  { name: "Santiago Rodríguez", color: "#86198F" },
  { name: "Santo Domingo", color: "#9D174D" },
  { name: "Valverde", color: "#701A75" },
];

export const PROVINCE_NAMES = DR_PROVINCES.map((p) => p.name);

const COLOR_MAP = DR_PROVINCES.reduce((acc, p) => { acc[p.name] = p.color; return acc; }, {});

export const provinceColor = (name) => COLOR_MAP[name] || "#64748B";
